import { clsx } from 'clsx';
import type { CSSProperties } from 'react';

interface SkeletonProps {
  variant?: 'rectangular' | 'circular';
  className?: string;
  style?: CSSProperties;
}

const baseClasses = clsx('bg-decorative');
const pulseClasses = clsx('animate-pulse');
const shapeClasses = {
  rectangular: clsx('rounded'),
  circular: clsx('rounded-full'),
};

const Skeleton = ({
  variant = 'rectangular',
  className,
  style,
}: SkeletonProps) => (
  <div
    data-testid="skeleton"
    className={clsx(
      baseClasses,
      pulseClasses,
      shapeClasses[variant],
      className,
    )}
    style={style}
  />
);

export default Skeleton;
